import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';


// hides children unless address is team address
export default function FeatureFlagGuard({ featureFlag, address, children }) {
	const router = useRouter();
	const show = useFeatureFlag( featureFlag, address );

	useEffect( () => {
		if ( show === false ) {
			router.replace( '/' );
		}
	}, []);

	return (
		<>{children}</>
	);
}


